import peoplePropertiesProvider from './peoplePropertiesProvider';

export default {
  __init__: [ 'peoplePropertiesProvider' ],
  peoplePropertiesProvider: [ 'type', peoplePropertiesProvider ]
};